import type { BoxProps } from '@mui/material/Box';

import { useRef, useState, useEffect } from 'react';

import Box from '@mui/material/Box';

import { scrollbarStyles } from 'src/sections/employer-data/shared/styles/sharedStyles';

type ScrollableBoxProps = BoxProps & {
  maxHeight?: string | number;
  padding?: number;
};

export function ScrollableBox({
  maxHeight = '50rem',
  padding,
  children,
  sx = [],
  ...other
}: ScrollableBoxProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
        // Check if scrolled to bottom (with 1px tolerance for rounding)
        const atBottom = Math.abs(scrollHeight - clientHeight - scrollTop) < 1;
        setIsAtBottom(atBottom);
      }
    };

    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll);
      // Initial check
      handleScroll();
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [children]);

  return (
    <Box
      ref={scrollRef}
      sx={[
        (theme) => ({
          maxHeight,
          overflowY: 'auto',
          overflowX: 'hidden',
          pr: padding ?? 1.5,
          marginBottom: isAtBottom ? 0 : -3,
          transition: 'margin-bottom 0.2s ease',
          ...scrollbarStyles(theme),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {children}
    </Box>
  );
}
